import {Injectable} from '@angular/core';
import {EspecialidadeModel, EspecialidadePrimaryKey} from "../models/especialidade.model";
import {CrudBaseService} from "./crud-base.service";
import {HttpClient} from "@angular/common/http";
import {IPrimaryKey} from "../interfaces/iprimary-key";
import {MedicoModel, MedicoPrimaryKey} from "../models/medico.model";

@Injectable({
  providedIn: 'root'
})
export class EspecialidadeService extends CrudBaseService<EspecialidadeModel> {

  constructor(http: HttpClient) {
    super(http, 'especialidade');
  }

  public getPk(id: EspecialidadePrimaryKey): EspecialidadePrimaryKey {
    return Object.assign(new EspecialidadePrimaryKey(), id);
  }

  public getByMedico(medicoId: IPrimaryKey<MedicoModel>) {
    let medicoPk = Object.assign(new MedicoPrimaryKey(), medicoId);
    return this.getByUrlQuery<EspecialidadeModel>(`medico/${medicoPk.id}`);
  }
}
